import script from "./LanguageSelectorBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelectorBar.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSelectorBar.vue?vue&type=style&index=0&id=14e6db06&scoped=true&lang=css"
import "./LanguageSelectorBar.vue?vue&type=style&index=1&id=14e6db06&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14e6db06"]])

export default __exports__